import { HostilityType } from "mmo-common";
import { Quat, Vector3 } from "realms-engine";
import { InterfaceSchema, isInterface } from "realms-utils";

/**
 * Represents an mmo creature
 */
export interface MMOCreature {
  /**
   * Whether the creature is dead or not
   */
  isDead(): boolean;

  /**
   * Gets the hostility type of the creature
   */
  getHostility(): HostilityType;

  /**
   * Position of the creature
   */
  getPosition(): Vector3;
  /**
   * Get Quaternion of creature
   */
  getQuaternion(): Quat;
}

const mmoCreatureSchema: InterfaceSchema<MMOCreature> = {
  isDead: "function",
  getHostility: "function",
  getPosition: "function",
  getQuaternion: "function",
};
export const isMMOCreature = isInterface<MMOCreature>(mmoCreatureSchema);
